// extracted by mini-css-extract-plugin
export default {"timelineTitle":"ClinicDetailAbout_timelineTitle__8hthI","about":"ClinicDetailAbout_about__qEWXG"};